// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"77b0b220","95":"15ccab2e","453":"c18763e6","531":"ad954282","548":"5bddbcc5","648":"d0719a04","728":"a0e1a22a","980":"6ae93c17"}[chunkId] + ".chunk.js";
};